module.exports = __webpack_public_path__ + "img/9788960512184.ee2ac0cd.jpg";